import api from './api';

export const getAllLocations = async (storeId) => {
  try {
    const response = await api.get('/locations', { params: { storeId } });
    return response.data;
  } catch (error) {
    console.error('Error retrieving locations', error);
    throw error;
  }
};

export const getLocationById = async (id) => {
    try{
        const response = await api.get('locations');
        return response.data;
    }catch(error){
        console.error("Error retrieving locations", error);
        throw error
    }
}

export const createLocation = async (data) => {
  try {
    const response = await api.post('/locations', data);
    return response.data;
  } catch (error) {
    console.error('Error retrieving locations', error);
    throw error;
  }
};

export const updateLocation = async (id, data) =>{
    try{
        const response = await api.put(`/locations/${id}`, data);
        return response.data;
    }catch(error){
        console.error('Error retrieving locations',error);
        throw error;
    }
}

export const deleteLocation = async (id) => {
    try{
        const response = await api.delete(`/locations/${id}`);
        return response.data;
    }catch(error){
        console.error('Error retrieving locations', error);
        throw error;
    }
}